module.exports = __webpack_public_path__ + "img/gl.cd5518e6.png";